import r from "./help-center-knowledge-anatomies14.js";
import i from "./help-center-knowledge-anatomies15.js";
import p from "./help-center-knowledge-anatomies16.js";
import e from "./help-center-knowledge-anatomies17.js";
import v from "./help-center-knowledge-anatomies18.js";
import m from "./help-center-knowledge-anatomies19.js";
import s from "./help-center-knowledge-anatomies20.js";
import a from "./help-center-knowledge-anatomies21.js";
import f from "./help-center-knowledge-anatomies22.js";
import C from "./help-center-knowledge-anatomies23.js";
import _ from "./help-center-knowledge-anatomies24.js";
import c from "./help-center-knowledge-anatomies25.js";
import E from "./help-center-knowledge-anatomies26.js";
import l from "./help-center-knowledge-anatomies27.js";
import u from "./help-center-knowledge-anatomies28.js";
import d from "./help-center-knowledge-anatomies29.js";
import F from "./help-center-knowledge-anatomies30.js";
import b from "./help-center-knowledge-anatomies31.js";
import h from "./help-center-knowledge-anatomies32.js";
import D from "./help-center-knowledge-anatomies33.js";
import N from "./help-center-knowledge-anatomies34.js";
import I from "./help-center-knowledge-anatomies35.js";
import g from "./help-center-knowledge-anatomies36.js";
import z from "./help-center-knowledge-anatomies37.js";
import L from "./help-center-knowledge-anatomies38.js";
import S from "./help-center-knowledge-anatomies39.js";
const n = {
  en_us: {
    vistaprint: r
  },
  en_gb: {
    vistaprint: i
  },
  en_au: {
    vistaprint: p
  },
  en_ca: {
    vistaprint: e
  },
  en_ie: {
    vistaprint: v
  },
  en_in: {
    vistaprint: m
  },
  en_nz: {
    vistaprint: s
  },
  en_sg: {
    vistaprint: a
  },
  de_de: {
    vistaprint: f
  },
  de_at: {
    vistaprint: C
  },
  de_ch: {
    vistaprint: _
  },
  fr_fr: {
    vistaprint: c
  },
  fr_be: {
    vistaprint: E
  },
  fr_ca: {
    vistaprint: l
  },
  fr_ch: {
    vistaprint: u
  },
  es_es: {
    vistaprint: d
  },
  es_us: {
    vistaprint: F
  },
  it_it: {
    vistaprint: b
  },
  it_ch: {
    vistaprint: h
  },
  nl_nl: {
    vistaprint: D
  },
  nl_be: {
    vistaprint: N
  },
  pt_pt: {
    vistaprint: I
  },
  da_dk: {
    vistaprint: g
  },
  sv_se: {
    vistaprint: z
  },
  fi_fi: {
    vistaprint: L
  },
  nb_no: {
    vistaprint: S
  }
}, nt = (o) => {
  const t = o?.toLowerCase()?.replace("-", "_");
  return n[t] ? { [t]: n[t] } : {
    en_us: {
      vistaprint: r
    }
  };
};
export {
  nt as getLocalizationResource
};
//# sourceMappingURL=help-center-knowledge-anatomies8.js.map
